import { Box, Typography, Avatar } from "@mui/material";

const InfoItem = ({ icon: Icon, label, value, color = "#0f172a", mb = 0 }) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', minWidth: 0, mb }}>
        <Avatar sx={{ bgcolor: (theme) => `${theme.palette.primary.main}33`, color: 'primary.main', mr: 1.5, width: 32, height: 32 }}>
            {Icon && <Icon sx={{ fontSize: 18 }} />}
        </Avatar>
        <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', mb: 0.5 }}>
                {label}
            </Typography>
            <Typography component="div" variant="body1" sx={{ overflowWrap: 'anywhere', fontWeight: 600, color, fontSize: '0.95rem' }}>
                {value === null || value === undefined || value === '' ? '—' : value}
            </Typography>
        </Box>
    </Box>
);

export default InfoItem;
